import { Navigate, useLocation, useParams } from "react-router";

import { logger } from "@/lib/logger";

import { BezettingHost } from "./bezetting/host";
import { resolveBezettingRoute } from "./bezetting/routing";
import { MaandrapportHost } from "./maandrapport/host";
import { resolveMaandrapportRoute } from "./maandrapport/routing";

/**
 * Bezettingsgraad at `/apps/bezetting/:tab?`: one route for every tab, so the
 * page and its renderer stay mounted while someone moves between tabs. An
 * old or unknown address goes on to the page it stands for (a replace, so
 * Back skips it), keeping the selections in the query.
 */
export function BezettingPage() {
  const { tab } = useParams();
  const { search } = useLocation();
  const route = resolveBezettingRoute(tab, search);
  if (route.kind === "redirect") {
    logger.debug("[nav]", "bezetting redirect", route.to.pathname);
    return <Navigate to={route.to} replace />;
  }
  return <BezettingHost tab={route.tab} />;
}

/**
 * Maandrapport at `/apps/maandrapport/:tab?/:client?`: one route for every tab and every client's page (under
 * Klanten), so the renderer stays mounted while someone moves between them. An unknown tab goes on to Overzicht (a
 * replace), keeping the range in the query.
 */
export function MaandrapportPage() {
  const { tab, client } = useParams();
  const { search } = useLocation();
  const route = resolveMaandrapportRoute(tab, search, client);
  if (route.kind === "redirect") {
    logger.debug("[nav]", "maandrapport redirect", route.to.pathname);
    return <Navigate to={route.to} replace />;
  }
  return <MaandrapportHost tab={route.tab} client={route.client} />;
}

/** `/apps` has no page of its own until there are several apps: on to Home. */
export function AppsIndex() {
  return <Navigate to="/home" replace />;
}
